<template>
  <div class="groups-inventory-modern">
    <div class="groups-main-container">
      <left-tabs :tabs="tabs" menu="tipo" class="modern-tabs">
        <template #groups>
          <Groups />
        </template>
        <template #categories>
          <Categories />
        </template>
        <template #group-categories>
          <GroupCategories />
        </template>
      </left-tabs>
    </div>
  </div>
</template>

<script>
import LeftTabs from "../Components/LeftTabs.vue";
import Groups from "./groups/groups.vue";
import Categories from "./items/categories.vue";
import GroupCategories from "./groups/group-categories.vue";

import permission from "../../lib/permission";

export default {
  name: "Items",

  components: { LeftTabs, Groups, GroupCategories, Categories },

  data() {
    return {
      tabs: [],
    };
  },

  created() {
    let tabs = [];

    if (permission("read", "stock")) {
      tabs.push({
        title: "GRUPOS",
        step: "groups",
        icon: "fas fa-warehouse",
      });
    }

    tabs.push({
      title: "CATEGORIAS",
      step: "categories",
      icon: "fas fa-tags",
    });

    tabs.push({
      title: "ASSOCIAR CATEGORIAS",
      step: "group-categories",
      icon: "fas fa-link",
    });

    this.tabs = tabs;
  },

  methods: {
    permission,
  },
};
</script>

<style scoped>
.groups-inventory-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.groups-main-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 24px;
}

/* Modern Tabs Enhancement */
.modern-tabs {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

/* Tab Content Area */
.modern-tabs >>> .tab-content {
  padding: 32px;
  background: transparent;
}

/* Tab Navigation Enhancement */
.modern-tabs >>> .nav-tabs {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 2px solid #e5e7eb;
  padding: 0 24px;
  margin: 0;
}

.modern-tabs >>> .nav-tabs .nav-link {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 16px 24px !important;
  margin: 0 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  color: #64748b !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.modern-tabs >>> .nav-tabs .nav-link:hover {
  color: #0f65b0 !important;
  background: rgba(15, 101, 176, 0.05) !important;
}

.modern-tabs >>> .nav-tabs .nav-link.active {
  color: #0f65b0 !important;
  background: transparent !important;
  border-bottom: 3px solid #0f65b0 !important;
  font-weight: 700 !important;
}

.modern-tabs >>> .nav-tabs .nav-link::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #0f65b0;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.modern-tabs >>> .nav-tabs .nav-link.active::before {
  transform: scaleX(1);
}

/* Tab Icons */
.modern-tabs >>> .nav-tabs .nav-link i {
  font-size: 14px;
  color: currentColor;
}

/* Enhanced Hover Effects */
.modern-tabs >>> .nav-tabs .nav-link:not(.active):hover {
  transform: translateY(-1px);
}

/* Active Tab Glow Effect */
.modern-tabs >>> .nav-tabs .nav-link.active {
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.15);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .groups-main-container {
    padding: 16px;
  }

  .modern-tabs >>> .tab-content {
    padding: 24px;
  }

  .modern-tabs >>> .nav-tabs {
    padding: 0 16px;
  }

  .modern-tabs >>> .nav-tabs .nav-link {
    padding: 14px 16px !important;
    font-size: 13px !important;
  }
}

@media (max-width: 768px) {
  .modern-tabs >>> .nav-tabs {
    flex-direction: column;
    padding: 16px;
  }

  .modern-tabs >>> .nav-tabs .nav-link {
    text-align: center !important;
    border-radius: 8px !important;
    margin-bottom: 8px !important;
    border: 1px solid #e5e7eb !important;
  }

  .modern-tabs >>> .nav-tabs .nav-link.active {
    background: #0f65b0 !important;
    color: white !important;
    border-color: #0f65b0 !important;
  }

  .modern-tabs >>> .nav-tabs .nav-link::before {
    display: none;
  }

  .modern-tabs >>> .tab-content {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .groups-main-container {
    padding: 12px;
  }

  .modern-tabs >>> .nav-tabs {
    padding: 12px;
  }

  .modern-tabs >>> .nav-tabs .nav-link {
    padding: 12px !important;
    font-size: 12px !important;
    flex-direction: column !important;
    gap: 4px !important;
  }

  .modern-tabs >>> .nav-tabs .nav-link i {
    font-size: 16px;
  }

  .modern-tabs >>> .tab-content {
    padding: 16px;
  }
}

/* Loading States */
.modern-tabs >>> .tab-pane {
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* Focus States for Accessibility */
.modern-tabs >>> .nav-tabs .nav-link:focus {
  outline: 2px solid #0f65b0;
  outline-offset: 2px;
}

/* Enhanced Box Shadow on Hover */
.modern-tabs:hover {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.3s ease;
}
</style>